/* ==========================================================================
   Personalisation fields on the product page.

   Handles the image dropzone, the character counter, and blocking add-to-cart
   until required fields are filled.

   Dawn intercepts the product form with its own <product-form> element, so
   validation runs on a CAPTURE-phase submit listener — that fires before
   Dawn's handler and can stop it with stopImmediatePropagation. A bubble-phase
   listener would run after the item was already on its way to the cart.
   ========================================================================== */

(function () {
  'use strict';

  var MAX_BYTES = 5 * 1024 * 1024;

  /* A 40 KB file reading "0.0 MB" looks like a failed upload. */
  function size(bytes) {
    return bytes < 1024 * 1024
      ? Math.max(1, Math.round(bytes / 1024)) + ' KB'
      : (bytes / 1024 / 1024).toFixed(1) + ' MB';
  }

  document.querySelectorAll('[data-eu-personalise]').forEach(setup);

  function setup(root) {
    if (root.dataset.euReady) return;
    root.dataset.euReady = '1';

    var form = root.closest('form[action*="/cart/add"]');
    var error = root.querySelector('.eu-pers__error');

    /* ── image fields ── */
    root.querySelectorAll('[data-eu-field="image"]').forEach(function (field) {
      var drop = field.querySelector('.eu-pers__drop');
      var input = field.querySelector('input[type=file]');
      var body = field.querySelector('.eu-pers__drop-body');
      var done = field.querySelector('.eu-pers__drop-done');
      var thumb = field.querySelector('.eu-pers__thumb');
      var name = field.querySelector('.eu-pers__filename');
      var linkBox = field.querySelector('.eu-pers__link');

      function accept(file) {
        if (!file) return;
        if (file.size > MAX_BYTES) {
          input.value = '';
          show('That image is over 5 MB. Paste a link to it instead — the option is just below the upload box.');
          if (linkBox) linkBox.open = true;
          return;
        }
        name.textContent = file.name + ' (' + size(file.size) + ')';
        body.hidden = true;
        done.hidden = false;
        clear();

        /* A thumbnail is worth the few lines: it is the only confirmation the
           customer gets that the right file went up. */
        if (/^image\//.test(file.type)) {
          var reader = new FileReader();
          reader.onload = function (e) { thumb.src = e.target.result; thumb.hidden = false; };
          reader.readAsDataURL(file);
        } else {
          thumb.hidden = true;
        }
      }

      input.addEventListener('change', function () { accept(this.files[0]); });
      drop.addEventListener('dragover', function (e) { e.preventDefault(); drop.classList.add('is-over'); });
      drop.addEventListener('dragleave', function () { drop.classList.remove('is-over'); });
      drop.addEventListener('drop', function (e) {
        e.preventDefault();
        drop.classList.remove('is-over');
        if (!e.dataTransfer.files.length) return;
        try {
          var dt = new DataTransfer();
          dt.items.add(e.dataTransfer.files[0]);
          input.files = dt.files;
        } catch (err) { /* older browsers: the click path still works */ }
        accept(e.dataTransfer.files[0]);
      });
      field.querySelector('.eu-pers__clear').addEventListener('click', function () {
        input.value = '';
        body.hidden = false;
        done.hidden = true;
        thumb.removeAttribute('src');
      });
      var link = field.querySelector('.eu-pers__link-input');
      if (link) link.addEventListener('input', clear);
    });

    /* ── character counters ── */
    root.querySelectorAll('.eu-pers__count').forEach(function (counter) {
      var max = Number(counter.getAttribute('data-max'));
      var input = counter.closest('.eu-pers__field').querySelector('input[type=text]');
      if (!input) return;
      var paint = function () {
        counter.textContent = input.value.length + ' / ' + max;
        counter.classList.toggle('is-full', input.value.length >= max);
      };
      input.addEventListener('input', function () { paint(); clear(); });
      paint();
    });

    root.querySelectorAll('.eu-pers__textarea, .eu-pers__select, .eu-pers__input')
      .forEach(function (el) { el.addEventListener('input', clear); el.addEventListener('change', clear); });

    function clear() { if (error) error.hidden = true; }
    function show(msg) {
      if (!error) return;
      error.textContent = msg;
      error.hidden = false;
      error.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    function missing() {
      var out = [];
      root.querySelectorAll('[data-required="true"]').forEach(function (field) {
        var label = field.getAttribute('data-label');
        var kind = field.getAttribute('data-eu-field');
        if (kind === 'image') {
          var file = field.querySelector('input[type=file]');
          var link = field.querySelector('.eu-pers__link-input');
          if (!(file && file.files.length) && !(link && link.value.trim())) out.push(label);
        } else {
          var el = field.querySelector('input, textarea, select');
          if (!el || !el.value.trim()) out.push(label);
        }
      });
      return out;
    }

    if (!form) return;
    form.addEventListener('submit', function (e) {
      var gaps = missing();
      if (gaps.length) {
        e.preventDefault();
        e.stopImmediatePropagation();
        show(
          gaps.length === 1
            ? 'Please complete "' + gaps[0] + '" before adding to cart.'
            : 'Please complete these before adding to cart: ' + gaps.join(', ') + '.'
        );
        return;
      }
      dropEmpties();
    }, true);

    /* An untouched optional field would otherwise submit as an empty property
       and print as a blank line on the order — most visibly the "… link" box
       that only exists for files too big to upload. Disabled inputs are left
       out of the FormData Dawn builds, then switched back on in case the add
       fails and the customer tries again. */
    function dropEmpties() {
      var off = [];
      root.querySelectorAll('input[name^="properties"], textarea[name^="properties"], select[name^="properties"]')
        .forEach(function (el) {
          var empty = el.type === 'file' ? !el.files.length : !el.value.trim();
          if (!empty) return;
          el.disabled = true;
          off.push(el);
        });
      if (off.length) setTimeout(function () { off.forEach(function (el) { el.disabled = false; }); }, 4000);
    }
  }
})();
